import styled from "styled-components";

const Divider = styled.div`
  height: 1px;
  width: 100%;
  background-color: #dfdfdf;
  margin: 0.5rem 0;
  border-radius: 0.0625em;
`;
export default Divider;
